// Import plugin files here.
// Import order will define navigation order
// If you get weird, unexpected errors, reload the page

// import '@/pages/Approvals/Approvals.plugin';
// import '@/pages/Assets/Assets.plugin';
// import '@/pages/Reports/Reports.plugin';


//import '@/pages/SalesOrders/SalesOrders.plugin'; //bb customer
//import '@/pages/Dashboard/Dashboard.plugin';     //bb customer
//import '@/pages/Purchasing/Purchasing.plugin'; 
//import '@/pages/Projects/Projects.plugin'; // disabled because this page heavily uses OMPG (not commonly used)
import '@/pages/WorkOrder/WorkOrder.plugin'; // disabled for now because most of the functionality will be in the scheduler 
import '@/pages/Warehouse/Warehouse.plugin';
import '@/pages/OrderEntry/OrderEntry.plugin';
import '@/pages/BPManagement/CustomerManagement/CustomerManagement.plugin';
import '@/pages/Items/Items.plugin';

// Referenceless plugin injection: any folder under src/nondev/ that contains a
// *.plugin.jsx file is auto-discovered and registered. Dropping a folder in
// registers a plugin; no host file names the plugin.
//
// Loaded lazily (deliberately NOT { eager: true }) and registered inside
// try/catch so that one broken or throwing nondev plugin is logged and skipped
// instead of white-screening the whole host app. The host must stay agnostic to
// nondev contents. (This guards runtime registration throws only; a plugin that
// imports a host module the host deleted is still a build-time failure, which is
// why the host plugin API is kept additive-only.)

// updated so it load nondev plugins without blocking the main portal render.
// this does not use a top-level await (which will force the app to wait for every
// plugin to finish registering before React could render). when in production that
// could cause a blank page if a plugin chunk was slow, missing, or failed during load.
//
// Promise.allSettled lets all matching plugins attempt to load in the background.
// added a try/catch for each plugin so one broken plugin is logged and
// skipped without preventing the rest of the portal from loading.
const nondevPlugins = import.meta.glob('/src/nondev/**/*.plugin.jsx');

const pluginPaths = Object.keys(nondevPlugins).sort();

console.log('[plugins] matched nondev plugin paths:', pluginPaths);

Promise.allSettled(
	pluginPaths.map(async (path) => {
		try {
			console.log(`[plugins] loading ${path}`);
			await nondevPlugins[path]();
			console.log(`[plugins] loaded ${path}`);
		} catch (err) {
			console.error(`[plugins] skipped ${path}:`, err);
		}
	})
);

console.log('[plugins] started loading all plugins');